import { useEffect, useCallback, useRef } from 'react';
import { chunk } from 'lodash';
import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
import { propsAreEqual } from '@tmsw/powerups.utils.props-are-equal';
import { GameBoardTileHtml } from '../GameBoardTile';

function HtmlGameBoard(props) {
  const { __t } = useTranslation('GAME_PLAY');

  const {
    pieces,
    board,
    // gameLevel,
    handleKeyDown,
    handleClick,
    gridItemProps,
    setGridItemProps,
    theme,
    viewport,
    refs,
  } = props;

  console.log('pieces', pieces);

  const { containerRef, gameboardRef } = refs;

  let chunkPieces = { ...pieces };
  chunkPieces = chunk(pieces, board.size.x);

  const calculateLayout = useCallback(() => {
    if (!gameboardRef.current) return;

    /*
     * @var {number} fudgeFactor
     * ⬣ Hexagons are calculated using a ∛/2 😱
     * and floating point math in JS is...unfortunate.
     * We scale the piece up, then scale the transtion equally
     */
    const fudgeFactor = 1.01;

    /**
     * The HTML Gamebaord children are all absolutely positioned.
     * We take the dimensions from the containing element
     */
    const boardBCR = gameboardRef.current.getBoundingClientRect();
    const boardImageBCR = document
      .querySelector('.hexgame-board-background')
      .getBoundingClientRect();
    // const hexWidth = boardBCR.width / (board.size.x - 1);
    const hexWidth = boardBCR.width / (board.size.x - 1);
    const hexHeightRatio = Math.sqrt(3) / 2;
    // console.log('hexWidth', hxexWidth);

    if (boardBCR.width === 0) {
      setTimeout(() => {
        calculateLayout();
      }, 5000);
    }

    const hexBCR = {
      width: hexWidth,
      height: hexWidth * hexHeightRatio,
    };

    const hexBB = { width: 20, height: 17.3205089569 }; // this is a constant
    const width = hexBCR.width * fudgeFactor;
    const height = width * hexHeightRatio;
    const scale = width / hexBB.width / fudgeFactor;

    const boardImageOffset = {
      x: (boardImageBCR.width - boardBCR.width) / 2,
      y: (boardImageBCR.height - boardBCR.height) / 2,
    };

    const containerBCR = containerRef.current.getBoundingClientRect();

    // offset for keyboard "drag"
    const keyboardDragOffset = {
      x: +(viewport.width - containerBCR.width) / 2,
      y: +(viewport.height - containerBCR.height) / 2,
    };

    // offset for touch drag
    const dragOffset = { x: +containerBCR.x, y: +containerBCR.y };

    console.log(
      'dragOffset',
      dragOffset,
      'keyboardDragOffset=',
      keyboardDragOffset
    );

    const newGridItemProps = {
      ...gridItemProps,
      ready: boardBCR.width > 0,
      // containerBCR,
      // boardBCR,
      boardImageBCR,
      boardImageOffset,
      tile: {
        width,
        height,
        scale,
      },
      preview: {
        dragOffset,
        keyboardDragOffset,
      },
    };

    if (!propsAreEqual(gridItemProps, newGridItemProps)) {
      setGridItemProps(newGridItemProps);
      document.querySelector('.hexgame-board').classList.remove('hide');
      document.querySelector('.GameCarousel')?.classList.remove('hide');
      console.log(' ≈(newGridItemProps);', newGridItemProps);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  useEffect(() => {
    window.addEventListener('orientationchange', calculateLayout);
    window.addEventListener('resize', calculateLayout);

    setTimeout(() => {
      calculateLayout();
    }, 2000);

    // Remove event listener on cleanup
    return () => {
      window.removeEventListener('orientationchange', calculateLayout);
      window.removeEventListener('resize', calculateLayout);
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  // console.log('GRID ITEM. PROPS=', gridItemProps);

  return (
    <div
      role="grid"
      aria-rowcount={board.size.x}
      aria-colcount={board.size.y}
      aria-labelledby="GameboardCaption"
      aria-roledescription={__t('locationGameboard')}
      id="Gameboard"
      ref={gameboardRef}
      // data-level={gameLevel}
      // data-bg={board.image}
      tabIndex="-1"
    >
      <span id="GameboardCaption" className="sr-only">
        {__t('gameboard')}
      </span>
      {gridItemProps.ready && (
        <>
          {chunkPieces.map((hexas, r) => (
            <div className="Gameboard-Row" role="row" tabIndex="-1" key={r}>
              <span role="rowheader" className="sr-only">
                {__t('{{row}} {{nRow}}', {
                  row: __t('row'),
                  nRow: r + 1,
                })}
              </span>
              {hexas.map((hex, index) => (
                <GameBoardTileHtml
                  board={board}
                  key={hex.id}
                  hex={hex}
                  ariaLabel={__t('tileDescription', {
                    description: hex.description,
                    row: __t('row'),
                    column: __t('column'),
                    nRow: hex.gridItem?.row,
                    nCol: hex.gridItem?.col,
                    x: index + 1,
                    tileState: hex.solved
                      ? __t('filledTile')
                      : __t('emptyTile'),
                  })}
                  theme={theme}
                  gridItemProps={gridItemProps}
                  handleKeyDown={handleKeyDown}
                  handleClick={handleClick}
                />
              ))}
            </div>
          ))}
        </>
      )}
    </div>
  );
}

export default HtmlGameBoard;
